document.addEventListener('click', function (e) {
  // Open modal
  const trigger = e.target.closest('[data-modal-target]');
  if (trigger) {
    const modal = document.getElementById(trigger.dataset.modalTarget);
    if (modal) {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
  }

  // Close modal
  const closeBtn = e.target.closest('[data-modal-close]');
  if (closeBtn) {
    const modal = closeBtn.closest('.icon-row-modal');
    if (modal) {
      modal.hidden = true;
      document.body.style.overflow = '';
    }
  }
});

// Close on Escape key
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.icon-row-modal:not([hidden])').forEach(function (modal) {
      modal.hidden = true;
      document.body.style.overflow = '';
    });
  }
});
